<template>
  <div class="pdt-20px column is-12">
    <div class="card mgb-20px" v-if="factureDetail.sens !== constantes.SENS_ACHAT">
      <header class="header-card">
        <p>
          {{ $t('echeancierPaiement.informationReglementFacture.title')}}
        </p>
      </header>
      <modifier-reglement
        :facture="factureDetail"
        @modeReglementChange="changeModeReglementInEcheancier"/>
    </div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionFacture.generalTitle.generalEcheancier')}}
        </p>
      </header>
      <div class="card-content">
        <qd-message type="is-warning" has-icon v-if="isLocked" :closable="false"
          icon-size="is-medium">
          <div class="columns is-vcentered">
            <div class="column is-10">
              <p class="has-text-weight-bold">
                {{ $t('detailClient.informations.lockTitle') }} {{getPayeur().nomCommercial}}
              </p>
              <p>{{ libelleBlocage() }}</p>
              <p>{{ getPayeur().descriptionBlocage }}</p>
            </div>
          </div>
        </qd-message>
        <div class="columns is-marginless is-paddingless is-multiline">
          <b-field class="obligatoire column is-2"
                   :label="$t('echeancierPaiement.generation.nbEcheances')">
            <b-input type="number" v-model="echeancierGeneration.nombreEcheances"></b-input>
          </b-field>
          <b-field class="obligatoire column is-2"
                   :label="$t('echeancierPaiement.generation.dateDebut')">
            <b-datepicker show-week-number
                          v-model="echeancierGeneration.datePremiereEcheance"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>
            </b-datepicker>
          </b-field>
          <b-field :label="$t('echeancierPaiement.generation.calerFinDuMois')"
            class="column is-narrow" custom-class="mgb-14px">
            <b-checkbox v-model="echeancierGeneration.calerFinDuMois">
            </b-checkbox>
          </b-field>
          <b-field class="obligatoire column is-2"
                   :label="$t('echeancierPaiement.generation.periodicite')">
            <b-select expanded
                      v-model="echeancierGeneration.periodicite">
              <option v-for="mode in periodicite"
                      :key="mode"
                      :value="mode">
                {{mode}}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t(factureDetail.sens === constantes.SENS_ACHAT ?
          'echeancierPaiement.generation.modePaiement'
          : 'echeancierPaiement.generation.modeReglement')"
                   class="column">
            <b-select expanded
                      v-model="echeancierGeneration.modeReglementId">
              <option></option>
              <option v-for="mode in modesReglement"
                      :key="mode.id"
                      :value="mode.id">
                {{mode.libelle}}
              </option>
            </b-select>
          </b-field>
          <b-field class="column is-2" label="-" custom-class="has-text-white">
            <b-tooltip
              :label="$t('echeancierPaiement.cantGenerate')"
              :active="cantGenerate"
              position="is-left">
              <a class="button is-primary"
                :class="{'disabled': cantGenerate}"
                @click="callPopup(true)">
                {{ $t('echeancierPaiement.generer')}}
              </a>
            </b-tooltip>
          </b-field>
          <div class="column is-12 columns">
            <p class="column is-narrow">
              {{ $t('echeancierPaiement.montantTotal')}}
              {{ echeancierGeneration.montantTotal | formatDevise }}
            </p>
            <b-field class="column is-narrow">
              <b-checkbox v-model="factureDetail.nePasRelancer">
                {{ $t('editionFacture.informations.nePasRelancer') }}
              </b-checkbox>
            </b-field>
          </div>
          <div class="column is-10 is-marginless is-multiline">
            <app-echeancier :echeancier="factureDetail.echeancierPaiement"
                            :montantTtc="echeancierGeneration.montantTotal"
                            :sens="factureDetail.sens"
                            @delete="supprimerEcheancier"
                            @deleteEcheance="suppprimerEcheance"
                            @archiverEcheance="archiverEcheance">
            </app-echeancier>
          </div>
        </div>
      </div>
      <b-modal v-model="popUpSuppresion" has-modal-card class="modal">
        <app-pop-up-suppression
          :messHeader="messHeader"
          :messFooter="messFooter"
          :cancel="cancelPopup"
          :validate="validatePopup"
          :isErrorPopup.sync='isErrorPopup'
          :messagesPopup='messagesPopup'
          oncancel="closePopUp()"
          @no="callPopup(false)"
          @yes="generationEcheancier()">
        </app-pop-up-suppression>
      </b-modal>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppEcheancier from '@/components/factures/echeancier';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import {
  JOUR, MOIS, ANNEE,
  TRIMESTRIEL, SEMESTRIEL, SENS_ACHAT, ETAT_ENREGISTRE,
} from '@/configuration/devisConf';
import calculDateEcheancier from '@/services/facture/dateDebutEcheancier';
import echeancierGeneration from '@/services/facture/generationEcheancier';
import AppPopUpSuppression from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import { NON_LETTRE } from '@/configuration/lettrageConf';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import calculArrondi from '@/services/calcul/calculArrondi';
import { LIBRE } from '@/configuration/tiers/levelBlocage';
import formatDate from '@/services/general/formatDate';
import levelString from '@/services/tiers/levelToString';
import ModifierReglement from './modifierReglement';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    factureDetail: Object,
    datePaiementBase: {
      type: Date,
      required: false,
    },
  },
  data() {
    return {
      popUpSuppresion: false,
      echeancierGeneration: {
        nombreEcheances: 1,
        datePremiereEcheance: this.factureDetail.dateFacture,
        periodicite: MOIS,
        montantTotal: calculArrondi(this.factureDetail.montantTtc
          - (this.factureDetail.montantAcomptesAffectes
            ? this.factureDetail.montantAcomptesAffectes : 0)),
        modeReglementId: this.factureDetail.modeReglementId,
        calerFinDuMois: false,
      },
      periodicite: [JOUR, MOIS, ANNEE, TRIMESTRIEL, SEMESTRIEL],
      isErrorPopup: false,
      messagesPopup: [''],
      constantes: {
        SENS_ACHAT,
        ETAT_ENREGISTRE,
      },
    };
  },
  components: {
    ModifierReglement,
    AppEcheancier,
    AppPopUpSuppression,
  },
  computed: {
    messHeader() {
      return this.$t('echeancierPaiement.generation.delete');
    },
    messFooter() {
      return this.$t('echeancierPaiement.generation.irreversible');
    },
    cancelPopup() {
      return this.$t('echeancierPaiement.generation.no');
    },
    validatePopup() {
      return this.$t('echeancierPaiement.generation.yes');
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    delaisReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.delaiReglement);
    },
    modesReglement() {
      if (this.factureDetail.sens === SENS_ACHAT) {
        return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement)
          .filter((modeReglement) => {
            return modeReglement.actionAchat !== AUCUN;
          });
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    cantGenerate() {
      const echeances = this.factureDetail.echeancierPaiement.find((echeance) => {
        return (echeance.etatLettrage && echeance.etatLettrage !== NON_LETTRE)
          || echeance.estRelance;
      });
      return !!echeances;
    },
    isLocked() {
      const payeur = this.getPayeur();
      if (payeur === undefined || payeur === null
        || payeur.blocageLevel === undefined) return false;
      return payeur.blocageLevel !== LIBRE;
    },
  },
  async mounted() {
    await this.loadParametres([
      typesParametres.PARAMETRES_KEYS.delaiReglement,
      typesParametres.PARAMETRES_KEYS.modeReglement,
    ]);
    this.factureDetail.delaiReglement = this.getDelai();
    if (this.factureDetail.delaiReglement) {
      this.echeancierGeneration.datePremiereEcheance = await this.calculDate(
        this.factureDetail.dateDevisCommande, this.factureDetail.delaiReglement,
        this.factureDetail.delaiReglementDetail,
      );
    } else if (this.factureDetail.sens === SENS_ACHAT && this.datePaiementBase) {
      this.echeancierGeneration.datePremiereEcheance = cloneDeep(this.datePaiementBase);
    } else this.echeancierGeneration.datePremiereEcheance = this.factureDetail.dateDevisCommande;
    this.factureDetail.echeancierPaiement.sort((a, b) => {
      const dateA = new Date(a.dateEcheance);
      const dateB = new Date(b.dateEcheance);
      return dateA - dateB;
    });
  },
  methods: {
    changeModeReglementInEcheancier(value) {
      this.echeancierGeneration.modeReglementId = value;
      this.factureDetail.modeReglementId = value;
    },
    getDelai() {
      const id = this.factureDetail.delaiReglementId;
      const delai = this.delaisReglement.find(item => {
        return item.id === id;
      });
      return delai;
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    calculDate(dateDevisCommande, delaiReglement, delaiReglementDetail) {
      if (delaiReglement.estPersonnalisable) {
        return calculDateEcheancier(dateDevisCommande, delaiReglementDetail);
      }
      return calculDateEcheancier(dateDevisCommande, delaiReglement.delaiReglementDetail);
    },
    callPopup(value) {
      this.popUpSuppresion = value;
    },
    async generationEcheancier() {
      this.popUpSuppresion = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.factureDetail.echeancierPaiement = (
          await echeancierGeneration(this.echeancierGeneration)
        ).data.result;
        this.$emit('updateMontant', this.echeancierGeneration.montantTotal);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.$emit('errorEvent', e.response);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
      }
    },
    supprimerEcheancier() {
      this.factureDetail.echeancierPaiement = [];
      const data = {
        ordre: 1,
        dateEcheance: this.echeancierGeneration.datePremiereEcheance,
        montant: this.echeancierGeneration.montantTotal,
        modeReglementId: this.factureDetail.modeReglementId,
      };
      this.factureDetail.echeancierPaiement.push(data);
    },
    suppprimerEcheance(index) {
      this.factureDetail.echeancierPaiement.splice(index, 1);
    },
    archiverEcheance(value) {
      this.factureDetail.echeancierPaiement[value.index].actif = !value.archive;
    },
    getPayeur() {
      if (this.factureDetail === undefined || this.factureDetail === null) return null;
      if (this.factureDetail.intervenants === undefined
        || this.factureDetail.intervenants.length === 0) return null;
      const payeur = this.factureDetail.intervenants.find(intervenant => {
        return intervenant.payeur !== undefined && intervenant.payeur === true;
      });
      return payeur ? payeur.tiers : null;
    },
    levelDateStr() {
      const payeur = this.getPayeur();
      if (payeur === null) return '';
      if (payeur.dateBlocageLevel === undefined
        || payeur.dateBlocageLevel == null) {
        return '';
      }
      return formatDate(payeur.dateBlocageLevel);
    },
    libelleBlocage() {
      const payeur = this.getPayeur();
      if (payeur === null) return '';
      return this.$i18n.t('detailClient.informations.locked', {
        level: levelString(this.$i18n, payeur.blocageLevel),
        dateLevel: this.levelDateStr(),
      });
    },
  },
};
</script>
